import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function FacebookTagIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon width="25px" height="25px" fill="none" viewBox="0 0 25 25" {...props}>
      <rect width="24.167" height="24.167" x=".167" y=".687" fill="#fff" rx="12.084" />
      <g clipPath={`url(#facebook-tag-a-${id}})`}>
        <path fill="#1977F3" d="M12.25 20.827a8.056 8.056 0 1 0 0-16.11 8.056 8.056 0 0 0 0 16.11Z" />
        <path
          fill="#fff"
          d="m15.386 15.1.357-2.329h-2.234V11.26c0-.637.311-1.259 1.313-1.259h1.016V8.02s-.922-.158-1.803-.158c-1.84 0-3.043 1.115-3.043 3.135v1.775H8.946v2.33h2.046v5.628a8.084 8.084 0 0 0 2.517 0V15.1h1.877Z"
        />
      </g>
      <path
        fill="#40DE9E"
        fillRule="evenodd"
        d="M12.25 22.84c5.562 0 10.07-4.509 10.07-10.07S17.812 2.7 12.25 2.7C6.69 2.7 2.18 7.21 2.18 12.77s4.51 10.07 10.07 10.07Zm0 2.014c6.674 0 12.084-5.41 12.084-12.084 0-6.674-5.41-12.083-12.083-12.083C5.577.687.167 6.097.167 12.77c0 6.674 5.41 12.084 12.084 12.084Z"
        clipRule="evenodd"
      />
      <defs>
        <clipPath id={`facebook-tag-a-${id}`}>
          <path fill="#fff" d="M4.195 4.714h16.111v16.111H4.195z" />
        </clipPath>
      </defs>
    </Icon>
  );
}
